import { FormContext, iControlProps } from "../types";
import React, { useEffect, useState } from "react";

type Props = iControlProps & {
    context: FormContext;
    formId: string;
    fieldId: string;
    form_field_tab_boi_table_searcher_field_target: string;
    form_field_tab_boi_table_searcher_target_new_value: string;
    form_field_tab_boi_table_searcher_rule: string;
    form_field_tab_boi_table_searcher_target_default_value: string;
};

export const getInputNamesFromString = (inputsString: string) => {
    return Array.from(inputsString.matchAll(/\{(\d+)\}/g)).map(
        (match: RegExpMatchArray) => `input_${match[1]}`
    );
};

export const getInputValuesFromContext = (
    inputNamesArray: any,
    context: FormContext
) => {
    const inputValuesObject = {} as any;
    for (const [fieldId, fieldValue] of Object.entries(context.getValues())) {
        if (inputNamesArray.includes(fieldId)) {
            inputValuesObject[fieldId] = fieldValue;

            /* istanbul ignore else */
            if (typeof fieldValue === "object") {
                inputValuesObject[fieldId] = fieldValue.value;
            }
        }
    }

    return inputValuesObject;
};

export const setContextFieldValue = (
    context: FormContext,
    inputId: string,
    inputValue: string
) => {
    context.setValue(`input_${inputId}`, inputValue);
};

export const unsetContextFieldValue = (
    context: FormContext,
    inputId: string
) => {
    context.unsetValue(`input_${inputId}`);
};

export const createNewTargetInput = (
    context: FormContext,
    stateTargetFieldValue: string
) => {
    const targetStringParts = Array.from(
        stateTargetFieldValue.matchAll(/\{(\d+)\}/g)
    );
    let newTargetValue = stateTargetFieldValue;
    targetStringParts?.forEach((inputId: any) => {
        let inputValueFromContext = context.getValue(`input_${inputId[1]}`);

        /* istanbul ignore else */
        if (typeof inputValueFromContext === "object") {
            inputValueFromContext = inputValueFromContext.value;
        }

        /* istanbul ignore else */
        if (typeof inputValueFromContext === "undefined") {
            inputValueFromContext = "";
        }
        newTargetValue = newTargetValue.replace(
            `{${inputId[1]}}`,
            inputValueFromContext
        );
    });

    return newTargetValue;
};

const TableSearcher = ({ ...props }: Props) => {
    const [inputsFromRuleString, setInputsFromRuleString] = useState({});
    const [inputsFromTargetString, setInputsFromTargetString] = useState({});
    const [allowedAPICall, setAllowedAPICall] = useState(true);
    const [allowedTargetFieldChange, setAllowedTargetFieldChange] = useState(
        false
    );
    const [targetFieldValue, setTargetFieldValue] = useState(
        props.form_field_tab_boi_table_searcher_target_new_value
    );

    const changedInputsFromRule = getInputNamesFromString(
        props.form_field_tab_boi_table_searcher_rule
    );
    const contextInputsFromRule = getInputValuesFromContext(
        changedInputsFromRule,
        props.context
    );

    const changedInputsFromTarget = getInputNamesFromString(
        props.form_field_tab_boi_table_searcher_target_new_value
    );
    const contextInputsFromTarget = getInputValuesFromContext(
        changedInputsFromTarget,
        props.context
    );

    /* istanbul ignore else */
    if (
        JSON.stringify(contextInputsFromTarget) !==
        JSON.stringify(inputsFromTargetString)
    ) {
        setInputsFromTargetString(contextInputsFromTarget);
        setAllowedTargetFieldChange(true);
    }
    if (
        JSON.stringify(contextInputsFromRule) !==
        JSON.stringify(inputsFromRuleString)
    ) {
        setInputsFromRuleString(contextInputsFromRule);
        setAllowedAPICall(true);
    }

    useEffect(() => {
        if (allowedTargetFieldChange) {
            const contextTargetFieldValue = createNewTargetInput(
                props.context,
                targetFieldValue
            );

            setContextFieldValue(
                props.context,
                props.form_field_tab_boi_table_searcher_field_target,
                contextTargetFieldValue
            );
            setAllowedTargetFieldChange(false);
        }
        if (allowedAPICall) {
            setContextFieldValue(props.context, props.fieldId, "searching");
            fetch(`${process.env.REACT_APP_API_TABLES}/${props.formId}/${props.fieldId}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    valuesForSearch: contextInputsFromRule
                })
            })
                .then(response => response.json())
                .then(data => {
                    unsetContextFieldValue(props.context, props.fieldId);
                    if (data.returnValue && data.returnValue !== "") {
                        setContextFieldValue(
                            props.context,
                            props.form_field_tab_boi_table_searcher_field_target,
                            data.returnValue
                        );
                        setTargetFieldValue(data.returnValue);
                        setAllowedTargetFieldChange(true);
                    } else {
                        setContextFieldValue(
                            props.context,
                            props.form_field_tab_boi_table_searcher_field_target,
                            props.form_field_tab_boi_table_searcher_target_default_value
                        );
                        setTargetFieldValue(
                            props.form_field_tab_boi_table_searcher_target_default_value
                        );
                    }
                })
                .catch(error => {
                    console.log(error);
                    unsetContextFieldValue(props.context, props.fieldId);
                });

            setAllowedAPICall(false);
        }
    }, [
        props,
        allowedAPICall,
        allowedTargetFieldChange,
        contextInputsFromRule,
        targetFieldValue
    ]);

    return <></>;
};

export default TableSearcher;
